// predictive-recipe-search.js
// Filtre ?ingredient= du blog recettes à partir de l'index léger (assets/recipes-index.js).

document.addEventListener('DOMContentLoaded', () => {
  const esc = (s) =>
    String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

  // Choix d'un ingrédient dans le drawer → page filtrée
  document.querySelectorAll('.ingredient-item input[type="radio"]').forEach((radio) => {
    radio.addEventListener('change', () => {
      window.location.href = `${window.location.pathname.split('/tagged/')[0]}?ingredient=${radio.value}`;
    });
  });

  const ingredient = new URLSearchParams(window.location.search).get('ingredient');
  const grid = document.querySelector('.blog-grid');
  if (!ingredient || !grid || !window.RecipesIndex) return;

  // Titre « Recettes avec <ingrédient> » (libellé accentué depuis le drawer si dispo)
  const input = document.querySelector(`input[name="ingredient"][value="${CSS.escape(ingredient)}"]`);
  const label = input?.parentElement.querySelector('label')?.textContent.trim() || ingredient;
  let recipesWith = 'Recipes with';
  try {
    recipesWith = JSON.parse(document.getElementById('blog-translations').textContent).recipes_with || recipesWith;
  } catch (e) {}
  const heading = document.querySelector('.title-wrapper .heading');
  if (heading) {
    heading.innerHTML = `<split-words class="split-words block" data-animate="fade-up-large">${esc(recipesWith)} ${esc(label)}</split-words>`;
  }

  grid.parentNode.querySelector('.pagination')?.remove();
  grid.className = 'blog-grid card-grid card-grid--3 mobile:card-grid--1 grid';

  const placeholder =
    'https://cdn.shopify.com/s/files/1/0556/0503/5347/files/no-image-recipe-placeholder.jpg?v=1749731852';
  const card = (r) => `
    <div class="card article-card relative flex flex-col gap-5 md:gap-8 leading-none">
      <div class="article-card__media relative overflow-hidden">
        <a href="${esc(r.u)}" class="article-card__link block relative media media--landscape" aria-label="${esc(r.t)}" tabindex="-1">
          <img src="${esc(r.img || placeholder)}" alt="${esc(r.t)}" width="1920" height="1080" loading="lazy" is="lazy-image" class="article-card__image loaded">
        </a>
      </div>
      <div class="article-card__content flex flex-col gap-5 md:gap-8">
        <div class="grid gap-4 md:gap-5">
          <p>
            <a class="article-card__title heading reversed-link text-lg-2xl leading-tight tracking-tight" href="${esc(r.u)}">${esc(r.t)}</a>
          </p>
          <div class="article-card__bottom rte leading-normal">${esc(r.e)}</div>
        </div>
        <p>
          <a class="link text-sm font-medium leading-tight plus" href="${esc(r.u)}">${esc(grid.dataset.readMore || 'Lire la suite')}</a>
        </p>
      </div>
    </div>`;

  const noResults = () => `
    <div class="text-center flex flex-col items-center gap-8 mt-8">
      <p class="text-lg-2xl">${esc(grid.dataset.noResults || 'Aucune recette trouvée')}</p>
      <a href="${esc(window.RecipesIndex.url)}" class="button button--primary button--md icon-with-text" is="hover-link">
        <span class="btn-fill" data-fill></span>
        <span class="btn-text">${esc(grid.dataset.viewAllRecipes || 'Voir toutes les recettes')}<svg class="icon icon-arrow-right icon-sm transform" viewBox="0 0 21 20" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 10H18M18 10L12.1667 4.16675M18 10L12.1667 15.8334"></path>
        </svg></span>
      </a>
    </div>`;

  window.RecipesIndex.get()
    .then((items) => {
      const matches = items.filter((r) => r.i === ingredient);
      grid.innerHTML = matches.map(card).join('');
      if (matches.length === 0) grid.insertAdjacentHTML('afterend', noResults());
    })
    .catch((error) => console.error('Erreur chargement des recettes :', error));
});
